module.exports = __webpack_public_path__ + "img/arrow_down.12d439db.png";